(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dd-feet-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dd-feet-choice')) {
  customElements.define('dd-feet-choice', class extends HTMLElement {
    connectedCallback() {
      this.main = this.closest('product-info');
      this.input = document.getElementById(`Quantity-${this.dataset.section}`);
      this.submit = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
      if (!this.main || !this.input || !this.submit || !this.main.contains(this.input)) return;
      this.buttons = [...this.querySelectorAll('[data-feet-count]')];
      this.status = this.querySelector('[data-feet-status]');
      this.total = this.querySelector('[data-feet-total]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency:this.dataset.currency || 'EUR'});
      this.canSelect = count => {
        const min = Number(this.input.min || 1);
        const max = this.input.hasAttribute('max') ? Number(this.input.max) : Infinity;
        const step = Number(this.input.step || 1);
        return !this.input.disabled && !this.submit.disabled && this.submit.getAttribute('aria-disabled') !== 'true' && count >= min && count <= max && step > 0 && (count - min) % step === 0;
      };
      this.sync = () => {
        const count = Number(this.input.value);
        const valid = Number.isInteger(count) && count > 0;
        this.buttons.forEach(button => {
          const option = Number(button.dataset.feetCount);
          const disabled = !this.canSelect(option);
          if (button.disabled !== disabled) button.disabled = disabled;
          const pressed = String(valid && option === count);
          if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
        });
        const price = valid ? this.money.format(count * Number(this.dataset.price) / 100) : '';
        const total = valid ? this.dataset.total.replace('[count]', count).replace('[price]', price) : '';
        const status = valid ? (count === 3 ? this.dataset.three : count === 1 ? this.dataset.one : this.dataset.many.replace('[count]', count)) : '';
        if (this.total.textContent !== total) this.total.textContent = total;
        if (this.status.textContent !== status) this.status.textContent = status;
      };
      this.onClick = event => {
        const button = event.target.closest('[data-feet-count]');
        if (!button || !this.contains(button)) return;
        const count = Number(button.dataset.feetCount);
        if (!this.canSelect(count)) return;
        this.input.value = String(count);
        this.input.dispatchEvent(new Event('input', {bubbles:true}));
        this.input.dispatchEvent(new Event('change', {bubbles:true}));
        this.sync();
      };
      this.addEventListener('click', this.onClick);
      this.input.addEventListener('input', this.sync);
      this.input.addEventListener('change', this.sync);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.main, {subtree:true, attributes:true, attributeFilter:['min','max','step','disabled','aria-disabled','class','data-cart-quantity']});
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.sync);
      this.querySelector('.dd-feet-choice__options').hidden = false;
      this.sync();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.input?.removeEventListener('input', this.sync);
      this.input?.removeEventListener('change', this.sync);
      this.observer?.disconnect();
      this.unsubscribeQuantity?.();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dd-mobile-buybar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dd-mobile-buybar')) {
  customElements.define('dd-mobile-buybar', class extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.native = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
      this.price = document.getElementById(`price-${this.dataset.section}`);
      if (!this.main || !this.native || !this.price) return;
      this.button = this.querySelector('[data-buybar-button]');
      this.onClick = () => { if (!this.native.disabled) this.native.click(); };
      this.button.addEventListener('click', this.onClick);
      this.sync = () => {
        const price = this.price.querySelector('.price--on-sale .price__sale .price-item--sale') || this.price.querySelector('.price__regular .price-item--regular');
        if (this.hasAttribute('data-feet-price')) {
          const count = Number(document.getElementById(`Quantity-${this.dataset.section}`)?.value || 1);
          const total = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency:this.dataset.feetCurrency || 'EUR'}).format(count * Number(this.dataset.feetPrice) / 100);
          this.querySelector('[data-buybar-price]').textContent = total;
          this.querySelector('[data-buybar-variant]').textContent = this.dataset.feetQuantity.replace('[count]', count);
        } else if (price) this.querySelector('[data-buybar-price]').textContent = price.textContent.trim();
        const choices = [...this.main.querySelectorAll('variant-selects input:checked, variant-selects option:checked')].map(input => input.value);
        if (!this.hasAttribute('data-feet-price')) this.querySelector('[data-buybar-variant]').textContent = choices.join(' / ');
        this.button.disabled = this.native.disabled || this.native.getAttribute('aria-disabled') === 'true';
        const label = this.native.querySelector('span:not(.loading__spinner)');
        if (label) this.button.textContent = label.textContent.trim();
        const error = this.main.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
        const message = this.querySelector('[data-buybar-error]');
        message.textContent = error?.textContent.trim() || '';
        message.hidden = !message.textContent;
        this.refresh();
      };
      this.refresh = () => {
        const overlay = document.querySelector('cart-drawer.active, .menu-drawer-container[open], product-modal[open], modal-dialog[open], quick-add-modal[open]');
        const nativeRect = this.native.getBoundingClientRect();
        const nativeVisible = this.media.matches && nativeRect.height > 0 && nativeRect.bottom > 0 && nativeRect.top < window.innerHeight;
        if (document.body.classList.contains('dd-main-buy-visible') !== nativeVisible) document.body.classList.toggle('dd-main-buy-visible', nativeVisible);
        const visible = this.media.matches && nativeRect.bottom < 0 && !overlay && !document.body.classList.contains('overflow-hidden');
        this.hidden = !visible;
        if (document.body.classList.contains('dd-buybar-visible') !== visible) document.body.classList.toggle('dd-buybar-visible', visible);
      };
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.refresh();
        });
      };
      window.addEventListener('scroll', this.onScroll, {passive:true});
      this.media = matchMedia('(max-width: 749px)');
      this.media.addEventListener('change', this.refresh);
      this.intersection = new IntersectionObserver(this.refresh);
      this.intersection.observe(this.native);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.main, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','checked','selected','hidden']});
      this.overlayObserver = new MutationObserver(this.refresh);
      this.overlayObserver.observe(document.body, {attributes:true,attributeFilter:['class']});
      const drawer = document.querySelector('cart-drawer');
      if (drawer) this.overlayObserver.observe(drawer, {attributes:true,attributeFilter:['class']});
      this.main.addEventListener('change', this.sync);
      this.main.addEventListener('input', this.sync);
      this.resize = new ResizeObserver(() => document.documentElement.style.setProperty('--dd-buybar-height', `${this.getBoundingClientRect().height}px`));
      this.resize.observe(this);
      this.sync();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.intersection?.disconnect(); this.observer?.disconnect(); this.overlayObserver?.disconnect(); this.resize?.disconnect();
      this.media?.removeEventListener('change', this.refresh);
      this.main?.removeEventListener('change', this.sync);
      this.main?.removeEventListener('input', this.sync);
      this.button?.removeEventListener('click', this.onClick);
      document.body.classList.remove('dd-buybar-visible', 'dd-main-buy-visible');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dd-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dd-product-description')) {
  customElements.define('dd-product-description', class extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector('[data-description]');
      if (!source) return;
      source.querySelectorAll(':scope > .dd-product-help').forEach(wrapper => wrapper.replaceWith(...wrapper.childNodes));
      const output = document.createDocumentFragment();
      let group = null;
      let lead = false;
      let originalDetailsSeen = false;
      const makeGroup = title => {
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        summary.textContent = title;
        details.append(summary);
        output.append(details);
        return details;
      };
      [...source.childNodes].forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) return;
        if (node.nodeName === 'H2') {
          group = makeGroup(node.textContent);
        } else if (node.nodeName === 'DETAILS') {
          output.append(node);
          group = null;
          originalDetailsSeen = true;
        } else if (originalDetailsSeen && !group && node.nodeName === 'P' && node.querySelector('a')) {
          output.append(node);
        } else if (!lead && !group && node.nodeName === 'P') {
          output.append(node);
          lead = true;
        } else {
          if (!group) group = makeGroup(this.dataset.about);
          group.append(node);
        }
      });
      [...output.children].filter(node => node.nodeName === 'DETAILS').forEach(details => {
        const content = [...details.childNodes].filter(node => node.nodeName !== 'SUMMARY');
        if (!content.some(node => node.nodeType === Node.ELEMENT_NODE || node.textContent.trim())) details.remove();
      });
      this.replaceChildren(output);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dd-review-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dd-review-ui')) {
  customElements.define('dd-review-ui', class extends HTMLElement {
    connectedCallback() {
      const update = widget => {
        const counter = widget.matches('[data-number-of-reviews]') ? widget : widget.querySelector('[data-number-of-reviews]');
        const empty = counter?.getAttribute('data-number-of-reviews') === '0' || Boolean(widget.querySelector('.jm-no-reviews-state'));
        if (widget.classList.contains('dd-reviews-empty') !== empty) widget.classList.toggle('dd-reviews-empty', empty);
        const set = (selector, value) => widget.querySelectorAll(selector).forEach(node => {
          if (node.textContent !== value) node.textContent = value;
        });
        if (this.dataset.language.startsWith('de')) {
          set('.jdgm-rev-widg__title', this.dataset.title);
          set('.jdgm-write-rev-link', this.dataset.write);
          widget.querySelectorAll('.jdgm-sort-dropdown option').forEach(option => {
            const key = {'Most Recent':'recent','Highest Rating':'high','Lowest Rating':'low','Only Pictures':'photos','Most Helpful':'helpful','Only Videos':'videos'}[option.textContent.trim()];
            if (key) option.textContent = this.dataset[key];
          });
          if (empty) set('.jdgm-rev-widg__summary-text, .jm-no-reviews-state__text', this.dataset.empty);
        }
      };
      const connect = () => {
        const widgets = document.querySelectorAll('.jdgm-review-widget');
        if (!widgets.length) return;
        this.discovery?.disconnect();
        this.watchers = [...widgets].map(widget => {
          update(widget);
          const observer = new MutationObserver(() => update(widget));
          observer.observe(widget,{subtree:true,childList:true,attributes:true,attributeFilter:['data-number-of-reviews']});
          return observer;
        });
      };
      this.discovery = new MutationObserver(connect);
      this.discovery.observe(document.body,{subtree:true,childList:true});
      connect();
    }
    disconnectedCallback() { this.discovery?.disconnect(); this.watchers?.forEach(observer => observer.disconnect()); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
